import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { getRefusals, getRefusalsBatches, getRefusalsFilterData, setChangedRefusalIds } from './refusals.actions';
import { Refusal, RefusalsBatch } from './refusals.types';
import { ReportFilterSettings } from '../reports/reports.types';

export type RefusalsState = {
  batches: RefusalsBatch[];
  refusals: Refusal[];
  changedRefusalIds: string[];
  filterSettings: ReportFilterSettings | null;
};

const initialState: RefusalsState = {
  batches: [],
  refusals: [],
  changedRefusalIds: [],
  filterSettings: null,
};

const refusalsReducer = createReducer(initialState, {
  [getRefusalsBatches.done.type]: (state: RefusalsState, action: ReturnType<typeof getRefusalsBatches.done>) => {
    return dotProp.set(state, 'batches', action.payload.result);
  },
  [getRefusals.done.type]: (state: RefusalsState, action: ReturnType<typeof getRefusals.done>) => ({
    ...state,
    refusals: action.payload.result,
  }),
  [setChangedRefusalIds.type]: (state: RefusalsState, action: ReturnType<typeof setChangedRefusalIds>) => ({
    ...state,
    changedRefusalIds: action.payload,
  }),
  [getRefusalsFilterData.done.type]: (state: RefusalsState, action: ReturnType<typeof getRefusalsFilterData.done>) => ({
    ...state,
    filterSettings: action.payload.result,
  }),
});

export default refusalsReducer;
